import { Grid, Typography } from "@mui/material";
import { NumberFormatInput } from "components/FormControls/NumberFormatInput";
import { RequiredFieldLabel } from "components/FormControls/RequiredFieldLabel";
import { SelectInput } from "components/FormControls/Select/Select";
import { limitsOptions } from "components/Layout/Campaign/utils/utils";
import { useMessage } from "hooks/intl";
import { AvailableLimitedAchievementPeriodsType } from "types/achievements";
import { useStyles } from "../../AchievementForm.styles";

interface Props {
  activeRule: number;
  errors?: any;
  ruleLimitType: AvailableLimitedAchievementPeriodsType;
}

export const RuleLimit = ({ activeRule, errors, ruleLimitType }: Props) => {
  const { message } = useMessage();
  const classes = useStyles();

  return (
    <>
      <Grid container spacing={10}>
        <Grid xs={12} item>
          <SelectInput
            width="100%"
            data-test-id={`rule-${activeRule}-limit-type`}
            items={limitsOptions.map((option) => ({
              id: option.value,
              label: message({ id: option.label }),
            }))}
            label={<RequiredFieldLabel text={message({ id: "timeframe" })} />}
            name={`rules[${activeRule}].limit.interval.type`}
          />
        </Grid>
        {ruleLimitType && ruleLimitType !== "noLimit" && (
          <Grid xs={12} item>
            <NumberFormatInput
              data-test-id={`rule-${activeRule}-limit-value`}
              label={
                <RequiredFieldLabel text={message({ id: "number/value" })} />
              }
              name={`rules[${activeRule}].limit.value`}
              error={errors?.limit?.value}
            />
          </Grid>
        )}
      </Grid>
      <Typography className={classes.descriptionNote} mt="16px">
        {message({ id: "limitsMemberInfo" })}
      </Typography>
    </>
  );
};
